import React from "react";
import { motion } from "framer-motion";
import { AirplaneTilt, Package, RoadHorizon, ArrowUpRight } from "@phosphor-icons/react";
import { useLang } from "../../context/LanguageContext";
import { mediaUrl } from "../../lib/api";
import { Reveal, Kicker } from "./Reveal";

const ICONS = { airport: AirplaneTilt, delivery: Package, longdistance: RoadHorizon };

export const Services = ({ content, onNav }) => {
  const { t, pick } = useLang();
  const services = content?.services || [];
  return (
    <section id="services" className="relative bg-taxi py-24 md:py-36" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <Reveal><Kicker>{t("services_kicker")}</Kicker></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-black text-6xl md:text-8xl uppercase">
                {t("services_title")}
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {services.map((s, i) => {
            const Icon = ICONS[s.id] || RoadHorizon;
            return (
              <Reveal key={s.id} delay={i * 0.1}>
                <motion.div whileHover={{ y: -8 }} transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                  className="group relative overflow-hidden border border-white/10 bg-surface h-full flex flex-col"
                  data-testid={`service-card-${s.id}`}>
                  <div className="relative h-56 overflow-hidden">
                    <img src={mediaUrl(s.image)} alt={pick(s, "title")}
                      className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-surface to-transparent" />
                    <div className="absolute top-4 left-4 h-12 w-12 bg-taxi flex items-center justify-center">
                      <Icon size={26} weight="bold" className="text-black" />
                    </div>
                  </div>
                  <div className="p-7 flex flex-col flex-1">
                    <h3 className="font-display text-white text-3xl uppercase mb-3 leading-none">{pick(s, "title")}</h3>
                    <p className="text-white/60 text-sm leading-relaxed flex-1">{pick(s, "desc")}</p>
                    <button onClick={() => onNav("book")} className="mt-6 self-start flex items-center gap-2 text-taxi font-bold text-sm uppercase tracking-wider group/btn">
                      {t("nav_book")}
                      <ArrowUpRight size={16} weight="bold" className="group-hover/btn:translate-x-1 group-hover/btn:-translate-y-1 transition-transform" />
                    </button>
                  </div>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
